<template>
    <div class="wb-catalog-button">
        <SVGList/>
    </div>
</template>

<script>
import SVGList from '@/UI/Components/SVG/SVGList.vue';

export default {
    name: 'SidebarMenuItemCatalog',
    components: { SVGList },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";

.wb-catalog-button {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid $green1;
    @include wb-c-flex-center;
    color: $green1;
    cursor: pointer;
    user-select: none;
}
</style>